import { render, staticRenderFns } from "./ForeignDocumentsOverlay.vue?vue&type=template&id=9d4ccc2c&"
import script from "./ForeignDocumentsOverlay.vue?vue&type=script&lang=ts&"
export * from "./ForeignDocumentsOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports